import {
    AfterContentInit, ChangeDetectionStrategy, ChangeDetectorRef,
    Component, EventEmitter,
    OnDestroy, Output,
} from "@angular/core";
import { Subscription } from "rxjs";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { FileUploadStateService } from "./fileupload-state.service";

@Component({
    selector: "common-fileupload",
    templateUrl: "./common-fileupload.component.html",
    styleUrls: ["./common-fileupload.component.scss"],
    exportAs: "CommonFileUpload",
    providers: [
        CommonFieldManagerDirective,
        { provide: FieldStateService, useClass: FileUploadStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormFileUploads" },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonFileUploadComponent implements OnDestroy, AfterContentInit {
    @Output() public ngModelChange = new EventEmitter<any[]>();
    public files: any[] = [];
    public state$: Subscription;

    constructor(
        public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
        public changeDetectorRef: ChangeDetectorRef,
    ) { }

    public ngAfterContentInit() {
        this.state$ = this.fieldStateService.stateObservable$.subscribe((state) => {
            this.files = state.value;
            this.ngModelChange.emit(this.files);
            this.changeDetectorRef.markForCheck();
        });
    }

    public ngOnDestroy() {
        this.state$.unsubscribe();
    }
}
